<template>
  <div v-if="totalPages > 0">
    <page-container
      v-for="(page, i) in totalPages"
      v-show="printMode || currentPage === page"
      :key="`page_${i}`"
      :currentPage="page"
      :totalPages="totalPages"
    >
      <section class="pdf-common-section">
        <div class="pdf-content-container">
          <i tabindex="0" hidefocus="true" id="pageTop" class="page-top-point"></i>
          <div class="pdf-header">
            <div class="pdf-title">
              <h2>{{ $locale("sideMenu.reports.pdfFilmFee") }}</h2>
            </div>
            <div class="pdf-header-left">
              <div class="pdf-header-left-inner">
                <span>{{ $locale('pdfFilmFeeBalance.monthDate') }}</span>
                <span>{{ `${$moment(pdfData.monthDate).format("YYYY" + $locale("global.year") + "MM" + $locale("global.month"))}` }}</span>
              </div>
              <div class="pdf-header-left-inner">
                <span>{{ $locale('filmFeePdf.targetTheater') }}</span>
                <span>{{ cinemaNames }}</span>
              </div>
            </div>
            <div class="pdf-header-right">
              <span>
                {{$locale("global.create")}}: {{ $moment(pdfData.exportAt).format("L LTS") }}
              </span>
              <span>
                Page: {{ page }} / {{ totalPages }}
              </span>
            </div>
          </div>

          <div class="pdf-listing-table">
            <el-table
              :id="'listTable'+i"
              ref="listTable"
              border
              width="100%"
              :data="pageListData(page)"
              :row-class-name="rowClassName"
              :span-method="({row, column, rowIndex, columnIndex}) => spanMethod({row, column, rowIndex, columnIndex}, pageListData(page))"
            >
              <el-table-column
                v-for="(item, idx) in thead"
                :resizable="false"
                :label="item.label"
                :min-width="item.width"
                header-align="center"
                :align="item.align"
                :prop="item.prop"
                :key="idx"
                :formatter="item.formatter"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </section>
    </page-container>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import PageContainer from "@/components/Report/PdfPageContainer.vue";
import { thead_fn, formatData } from "@/assets/js/pdfFilmFee";

export default {
  name: "Film-Fee-Pdf",
  components: {
    // ItemListTable,
    PageContainer
  },
  props: {
    pdfData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      printMode: false,
      currentPage: 1,
      pageHeight: 600,
      pageListCounts: [],
    };
  },
  computed: {
    cinemaNames() {
      if (!this.pdfData) { return ""; }

      return this.pdfData.cinemaName || "";
    },
    thead() {
      return thead_fn();
    },
    tableData() {
      const { records, allTotal } = this.pdfData;
      if (!records || !allTotal) {
        return [];
      }

      const _data = tranfResData(this.pdfData);
      return formatData(_data);
    },
    totalPages() {
      const _page = this.pageListCounts.length;
      return _page === 0 ? 1 : _page;
    },
  },
  watch: {
    pdfData(_nv) {
      if (!_nv || _nv.length === 0) {
        return;
      }

      this.pageListCounts = [];
      this.setPrintMode(false);
      const vm = this;

      vm.$nextTick(() => {
        const _target = document.getElementById("listTable0");
        const _rows = _target.getElementsByClassName("el-table__row");
        let _pageCHeight = 0;

        _rows.forEach((__row, idx) => {
          _pageCHeight += __row.clientHeight;

          if (_pageCHeight >= this.pageHeight) {
            this.pageListCounts.push(idx);

            _pageCHeight = 0;
            _pageCHeight += __row.clientHeight;
          }
        });

        const _lastItem = this.pageListCounts[this.pageListCounts.length - 1];
        if (_lastItem !== _rows.length - 1) {
          this.pageListCounts.push(_rows.length);
        }

        this.setPrintMode(true);
        this.$emit("printPDF");
      });
    },
  },
  methods: {
    setPrintMode(status) {
      this.currentPage = 1;
      this.printMode = status;
    },
    pageListData(page) {
      if (!this.tableData || this.tableData.length === 0) { return []; }

      let lists = [];

      if (this.printMode && this.pageListCounts.length > 0) {
        this.pageListCounts.forEach((_count, i) => {
          const startCount = page === 1 ? 0 : this.pageListCounts[page - 2];
          const size = _count;

          if (i + 1 > page || startCount + 1 > size) { return; }

          lists = [ ...this.tableData.slice(startCount, size) ];
        });

        return [ ...lists ];
      }
      return [ ...this.tableData ];
    },
    rowClassName({ row }) {
      if (row.isTotalRow) {
        return "all-total total-row";
      } else if (row.isSumsRow) {
        return "all-total sums-row";
      } else if (row.isFilmTotalRow) {
        return "all-total film-total-row";
      }
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      for(let i = 0; i < model.length; i++) {
        if (i === 0 || i === model.length - 1) {
          spanArr.push(1);
          pos = 0;
        } else if(model[i][key] === model[i - 1][key] && model[i].clientName === model[i - 1].clientName) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    mergeComon(key, rowIndex, data) {
      const _row = this.getCount(data, key)[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    spanMethod({ rowIndex, columnIndex }, data) {
      switch(columnIndex) {
      case 0:
        return this.mergeComon("clientName", rowIndex, data);
      case 1:
        return this.mergeComon("filmName", rowIndex, data);
      case 2:
        return this.mergeComon("dateRange", rowIndex, data);
      case 8:
        return this.mergeComon("dateRange", rowIndex, data);
      default:
        break;
      }
    }
    // spanMethod({ row, rowIndex, columnIndex }) {
    //   const { isSumsRow, isTotalRow, isFilmTotalRow, sumRowCounts } = row;

    //   if (isTotalRow || isFilmTotalRow) {
    //     if (columnIndex < 3) {
    //       if (rowIndex % 5 === 0) {
    //         if (columnIndex === 0) {
    //           return [5, 3];
    //         }
    //         return [0, 0];
    //       }
    //       return [0, 0];
    //     }
    //   } else if (isSumsRow) {
    //     if (columnIndex < 3) {
    //       if (sumRowCounts) {
    //         if (columnIndex === 0) {
    //           return [6, 3];
    //         }
    //         return [0, 0];
    //       }
    //       return [0, 0];
    //     }
    //   } else if (columnIndex < 3) {
    //     if (rowIndex % 5 === 0) {
    //       return [5, 1];
    //     }
    //     return [0, 0];
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
  @import url("../../../assets/style/reportPdf.less");
</style>